import { Box, Dialog, DialogTitle, Typography } from "@mui/material"
import { AddOutlined, CloseFilledOutlined, WarningOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

import { Button } from "@/components/common/Button"

interface RemovePrimaryContactProps {
  onClose: () => void
  onConfirm: () => void
  addPrimaryContact?: () => void
}
const RemovePrimaryContact: FC<RemovePrimaryContactProps> = ({ addPrimaryContact, onConfirm, onClose }) => {
  return (
    <Dialog open={true} onClose={onClose} maxWidth='sm' fullWidth>
      <DialogTitle>
        <Box display='flex' justifyContent='flex-end'>
          <Button size='small' appearance='text' onClick={() => onClose()}>
            <CloseFilledOutlined className='text-blue-gray' />
          </Button>
        </Box>
      </DialogTitle>
      <Box className='w-full justify-center text-center'>
        <WarningOutlined className='size-[48px] text-secondary-600' />
        <Typography variant='h5' color='primary' className='mt-6 font-normal'>
          Are you sure you want to remove the primary contact for this location?
        </Typography>
        <Typography variant='h6' className='my-6 px-3 text-base leading-[150%] tracking-[-0.85px] text-gray-700'>
          You will no longer have a primary contact for this companies location.
        </Typography>
      </Box>
      <Box className='flex justify-between' p={4}>
        <Box>
          <Button appearance='outlined' variant='secondary' className='mr-2' onClick={() => onClose()}>
            Close
          </Button>
        </Box>

        <Box display='flex'>
          {addPrimaryContact ? (
            <Button
              appearance='text'
              variant='secondary'
              startIcon={<AddOutlined fontSize='small' />}
              className='mr-2'
              onClick={() => addPrimaryContact()}
            >
              Add Primary Contact
            </Button>
          ) : null}
          <Button
            variant='error'
            onClick={() => {
              onConfirm()
              onClose()
            }}
          >
            Proceed
          </Button>
        </Box>
      </Box>
    </Dialog>
  )
}

export default RemovePrimaryContact
